
import { useAppDispatch } from "app.hook";
import React, { FC, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {  BILLING_ADDRESS_ADD_ROUTE, BILLING_ADDRESS_EDIT_ROUTE, BILLING_ADDRESS_ROUTE, SHIPPING_ADDRESS_ADD_ROUTE, SHIPPING_ADDRESS_EDIT_ROUTE, SHIPPING_ADDRESS_ROUTE } from "shared/constants/routes";
import { formatPhone } from "shared/plugins/string-helper";
import { getCustomerAddressesAPI, removedCustomerAddressesAPI } from "states/customer-address/customer-address.api";
import { AddressTypeEnum, ICustomerAddressModel } from "states/customer-address/customer-address.models";
import { setActiveMenu, setLoading, showSuccess } from "states/global-value/global-value.slice";
import { IconPlus } from "themes/icons";

import { AddressBtnContainer, ItemAddressContainer } from "./style/address-style";

const AddressPage: FC = (props) => {
  const dispatch = useAppDispatch();
  const [addresses, setAddresses] = useState<ICustomerAddressModel[]>([]);
  const [addressType,setAddressType] = useState<AddressTypeEnum>(document.location.href.indexOf("/billing") > -1 ? AddressTypeEnum.Billing : AddressTypeEnum.Shipping);

  const getCustomerAddress = async () => {
    dispatch(setLoading(true));
    let response = await getCustomerAddressesAPI();
    console.log(addressType);
    setAddresses(response.data.filter(m=> m.addressType === addressType));
    dispatch(setLoading(false));
  }
  const removeAddress = async (id: number) =>{
    dispatch(setLoading(true));
    try{
      await removedCustomerAddressesAPI(id);
      await getCustomerAddress();
      dispatch(showSuccess("Removed Data Successfully"));
      dispatch(setLoading(false));
    }catch(err){
      dispatch(setLoading(false));
    }
  }
  useEffect(() => {
    document.title = "User Info";
    setAddressType(document.location.href.indexOf("/billing") > -1 ? AddressTypeEnum.Billing: AddressTypeEnum.Shipping);
    getCustomerAddress();
    dispatch(setActiveMenu(document.location.href.indexOf("/billing") > -1 ? "billing": "shipping"));
  }, [])
  return (
    <>
      <AddressBtnContainer>
        <Link to={`${addressType === AddressTypeEnum.Billing ? BILLING_ADDRESS_ADD_ROUTE
          : SHIPPING_ADDRESS_ADD_ROUTE}`} ><IconPlus width={20} /> Add new address</Link>
      </AddressBtnContainer>
      <div className="inner">
        {addresses?.map(m => (
          <ItemAddressContainer>
            <div className="info">
              <div className="address">
                {m.addressInfo.street},<br/> {m.addressInfo.provinceName}, {m.addressInfo.stateCode} {m.addressInfo.postalCode}, {m.addressInfo.countryCode}
              </div>
              <div className="name">
                {`${m.addressInfo.firstName} ${m.addressInfo.lastName}`.toUpperCase()} - {m.addressInfo.phoneNumber && formatPhone(m.addressInfo.phoneNumber)}
              </div>
            </div>
            <div className="action"><Link className="edit" to={`${addressType === AddressTypeEnum.Billing ? BILLING_ADDRESS_EDIT_ROUTE : SHIPPING_ADDRESS_EDIT_ROUTE}/${m.id}`}>Edit</Link>
              <button className="delete" onClick={() => {
                if (window.confirm("Are you sure remove this address")) {
                  removeAddress(Number(m.id));
                }
              }}>Remove</button>
            </div>
          </ItemAddressContainer>
        ))}
      </div>
    </>
  );
};

export default AddressPage;
